import {onFind} from "@elements/init-modules-in-scope";
import {removeClass,on, addClass, findIn, findAllIn} from '@elements/dom-utils';

const defaultOptions = {};

const defaultSelectors = {
    base: '.js-console',
    item: '.js-console__item',
    fixedItem: '.js-console__item--fixed',
    link: '.console__link',
};

const isMobile = matchMedia('(max-width: 767px)').matches || false;
export function init(options = defaultOptions, selectors = defaultSelectors) {
    onFind(selectors.base, function (baseElement) {
        if(isMobile) return;
        let fixedItem = findIn(selectors.fixedItem, baseElement);
        on('scroll', function () {
            if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                addClass('is-hidden', baseElement);
            } else {
                removeClass('is-hidden', baseElement);
            }
        }, window)
        on('mouseenter', function(){
            removeClass('is-hidden', baseElement);
        }, fixedItem)

        on('keydown', function(event) {
            if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

            const links = findAllIn(selectors.link, baseElement);
            const currentIndex = links.indexOf(document.activeElement);

            if (currentIndex === -1) return;
            event.preventDefault();

            let nextIndex;
            if (event.key === 'ArrowDown')
                nextIndex = (currentIndex + 1) % links.length;
            else
                nextIndex = (currentIndex - 1 + links.length) % links.length;

            links[nextIndex].focus();
        }, baseElement);
    });
}
